import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { appendQuery } from '../../shared/utils/commenFunctions';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';

export interface ActivityApiResponse {
  statusCode: number;
  message: string;
  total: number;
  activities: ActivityApiItem[];
}

export interface ActivityApiItem {
  id: string;
  activityName: string;
  activityImage: string;
  groupName: string;
  type?: string | null;
  /** Special activities belong under Upcoming Events, not Activity Screen. */
  isSpecial?: boolean;
  createdDate: string;
}

export interface ParticipateActivityPayload {
  userId: number;
  activityId: string[];
  /** Calendar day (yyyy-MM-dd) this selection applies to. */
  date?: string;
}

export interface ParticipateActivityResponse {
  statusCode: number;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiService);
  private readonly baseUrl = environment.host;

  /**
   * Fetches the list of activities from the API
   * @param payload Query parameters (index, limit, etc.)
   * @returns Observable containing the activity list response
   */
  getActivities(payload: Record<string, unknown> = {}): Observable<ActivityApiResponse> {
    const url = appendQuery(`${this.baseUrl}${API_ENDPOINTS.BASE_PATH}${API_ENDPOINTS.ACTIVITIES.LIST}`, payload);
    return this.http.get<ActivityApiResponse>(url);
  }

  /**
   * Participates in an activity
   * @param payload Contains userId and activityId
   * @returns Observable containing the participation response
   */
  participateInActivity(payload: ParticipateActivityPayload): Observable<ParticipateActivityResponse> {
    return this.apiService.post<ParticipateActivityResponse>(API_ENDPOINTS.ACTIVITIES.PARTICIPATE, payload);
  }
}

